import apiService from "./apiService";


const formDataConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  }
}

const requestUploadImage = (image) => {
  const formData = new FormData();
  formData.append('image', image)
  return apiService.post(URIS.imageUpload, formData, formDataConfig);
}

export const requestUploadDynamicCmsImage = (image) => {
  const formData = new FormData();
  formData.append('image_url', image)
  return apiService.post(URIS.cmsImageUpload, formData, formDataConfig);
}

const requestRemoveImage = (imageUrl) => {
  return apiService.delete(URIS.imageUpload, {data: {image: imageUrl}})
}

export const requestRemoveDynamicCmsImage = (imageUrl) => {
  return apiService.delete(URIS.cmsImageUpload, {data: {image: imageUrl}})
}


export {requestUploadImage, requestRemoveImage}

const URIS = {
  imageUpload: '/cms/banner-uploads',
  cmsImageUpload: '/cms/dynamic-pages/images'
}
